module.exports = __webpack_public_path__ + "fonts/mc.dd022a2.ttf";